import { TimelineLite, TweenMax, Power4 } from 'gsap';
import ScrollMagic from '../../plugins/ScrollMagic';
import '../../plugins/debug.addIndicators';
import globals from '../../globals';
import { isMobile } from "react-device-detect";

export default {

    initialise() {
        this.controller = new ScrollMagic.Controller();
        setTimeout(() => {
        	this.scrollText();
            this.intro1();
            this.portrait();
            this.intro2();
            this.whatIDo();
            this.intro3();
            this.work();
            this.intro4();
            this.contact();
        }, 250);
    },

	resetWhatIDo() {
    	this.whatIDoScene.destroy(true);
		this.whatIDoScene = null;
		this.whatIDo();
	},

	scrollText() {
		let component = document.getElementById('scroll'),
			trigger = document.getElementById('intro1'),
			items = component.querySelectorAll('span'),
			tl = new TimelineLite();

		let itemsArr = [...items].reverse();
		itemsArr.forEach(item => {
			let x = this.getRandomInt(),
				y = this.getRandomInt();
			tl.to(item, 0.5, {x: x, y: y, opacity: 0}, 0);
		});

		new ScrollMagic.Scene({
			triggerElement: trigger,
			triggerHook: 'onEnter',
			offset: 50,
			duration: 1000
		})
			.setTween(tl)
			//.addIndicators({name: 'scroll'})
			.addTo(this.controller);
	},

    intro1() {
        let component = document.getElementById('intro1'),
            pin = component.querySelector('.sub-heading'),
            trigger = component.querySelector('.trigger');

		if (!isMobile) {
			this.sceneIntro1 = new ScrollMagic.Scene({
				triggerElement: trigger,
				offset: 100,
				duration: 850
			})
				.setPin(pin, {
					pushFollowers: false
				})
				//.addIndicators({name: 'intro1'})
				.addTo(this.controller);
		}
    },

    portrait() {
        if (!isMobile) {
			let component = document.getElementById('josh'),
				portrait = component.querySelector('.portrait-inner'),
				offset = this.sceneIntro1.triggerPosition() + this.sceneIntro1.duration(),
				whyComponent = document.getElementById('why'),
				whyInner = whyComponent.querySelector('.inner'),
				whyContent = whyComponent.querySelector('.content');

			TweenMax.set(whyContent, {y: 75, opacity: 0});

			this.scenePortrait = new ScrollMagic.Scene({
				triggerElement: 'body',
				offset: offset + 10,
				duration: 900
			})
				.setPin(portrait)
				.on('progress', (event) => {
					if (event.scrollDirection === 'FORWARD' && event.progress > 0.8) {
						TweenMax.to(whyContent, 0.5, {y: 0, opacity: 1});
					}
				})
				//.addIndicators({name: 'portrait1'})
				.addTo(this.controller);

			let tl = new TimelineLite();
			tl.to(whyInner, 1, {y: 100});
			tl.to(portrait, 1, {y: -200}, 0);

			new ScrollMagic.Scene({
				triggerElement: 'body',
				offset: this.scenePortrait.triggerPosition() + this.scenePortrait.duration(),
				duration: 750
			})
				.setTween(tl)
				//.addIndicators({name: 'portrait2'})
				.addTo(this.controller);
		}
    },

    intro2() {
        let component = document.getElementById('intro2'),
			trigger = component.querySelector('.trigger'),
			heading = component.querySelector('.sub-heading');

		this.slowIntroScroll(heading, trigger, 'intro2');
    },

    whatIDo() {
        let component = document.getElementById('what-i-do'),
            trigger = component.querySelector('.trigger'),
            heading = component.querySelectorAll('.heading h1, .heading span'),
            panels = component.querySelector('.panels .inner'),
            tl2 = new TimelineLite(),

            clientPanel = panels.querySelector('#client-panel'),
            serverPanel = panels.querySelector('#server-panel'),
            miscPanel = panels.querySelector('#misc-panel'),

			colorFaded = globals.getCssVar('--color-primary') === '#ff0042' ? 'rgba(255, 0, 66, 0.2)' : 'rgba(7, 253, 216, 0.2)',
			colorFull = globals.getCssVar('--color-primary') === '#ff0042' ? 'rgba(255, 0, 66, 1)' : 'rgba(7, 253, 216, 1)';

        heading.forEach(item => {
            let x = this.getRandomInt(),
                y = this.getRandomInt();
            tl2.to(item, 0.5, {x: x, y: y, opacity: 0}, 0);
        });

        tl2.set([
        	clientPanel.querySelectorAll('.panel'),
			serverPanel.querySelectorAll('.panel'),
			miscPanel.querySelectorAll('.panel')
		], {borderColor: colorFaded}, 0);

        tl2.set([
        	clientPanel.querySelector('svg'),
			serverPanel.querySelector('svg'),
			miscPanel.querySelector('svg')
		], {opacity: 0.3}, 0);

        tl2.to(clientPanel, 0.15, {y: -100}, 0.01);
        tl2.to(clientPanel.querySelectorAll('.panel'), 0.15, {borderColor: colorFull}, 0.01);
        tl2.to(clientPanel.querySelectorAll('svg'), 0.15, {opacity: 1}, 0.01);

		tl2.to(serverPanel, 0.15, {y: -100}, 0.15);
		tl2.to(serverPanel.querySelectorAll('.panel'), 0.15, {borderColor: colorFull}, 0.15);
		tl2.to(serverPanel.querySelectorAll('svg'), 0.15, {opacity: 1}, 0.15);

		tl2.to(miscPanel, 0.15, {y: -100}, 0.3);
		tl2.to(miscPanel.querySelectorAll('.panel'), 0.15, {borderColor: colorFull}, 0.3);
		tl2.to(miscPanel.querySelectorAll('svg'), 0.15, {opacity: 1}, 0.3);

        this.whatIDoScene = new ScrollMagic.Scene({
            triggerElement: trigger,
            duration: '400%'
        })
            .setPin(panels, {
                pushFollowers: true
            })
            .setTween(tl2)
            // .addIndicators({name: 'whatIDo'})
            .addTo(this.controller);
    },

	intro3() {
		let component = document.getElementById('intro3'),
			trigger = component.querySelector('.trigger'),
			heading = component.querySelector('.sub-heading');

		this.slowIntroScroll(heading, trigger, 'intro3');
	},

	work() {
		let component = document.getElementById('work'),
			trigger = component.querySelector('.trigger'),
			pointer = component.querySelector('.pointer');

		let tl = new TimelineLite();
		tl.to(pointer, 0.5, {x: 15, ease: Power4.easeInOut});
		tl.to(pointer, 0.1, {scale: 0.9}, '-=0.10');
		tl.to(pointer, 0.1, {scale: 1});
		tl.to(pointer, 0.5, {x: 0, ease: Power4.easeOut});
		tl.to(pointer, 0.5, {x: 15, ease: Power4.easeInOut}, '-=0.20');
		tl.to(pointer, 0.1, {scale: 0.9}, '-=0.10');
		tl.to(pointer, 0.1, {scale: 1});
		tl.to(pointer, 0.5, {x: 0, ease: Power4.easeOut});

		new ScrollMagic.Scene({
			triggerElement: trigger,
			offset: 150,
			reverse: false
		})
			.setTween(tl)
			//.addIndicators({name: 'work'})
			.addTo(this.controller);
	},

	intro4() {
		let component = document.getElementById('intro4'),
			trigger = component.querySelector('.trigger'),
			heading = component.querySelector('.sub-heading');

		this.slowIntroScroll(heading, trigger, 'intro4');
	},

	contact() {
		let component = document.getElementById('contact'),
			trigger = component.querySelector('.trigger'),
			headings = component.querySelectorAll('.heading span'),
			nz = component.querySelector('.nz'),
			au = component.querySelector('.au'),
			tl = new TimelineLite();

		let positions = {};
		headings.forEach((item, key) => {
			let style = getComputedStyle(item);
			positions[key] = {left: style.left, top: style.top};
		});

		tl.from(headings, 0.75, {delay: 0.5, opacity: 0});
		headings.forEach((item, key) => {
			let style = positions[key];
			tl.fromTo(item, 0.75, {top: 0, left: 0}, {top: style.top, left: style.left}, 0);
		});

		tl.to(nz, 0.25, {delay: 1, scale: 1.35});
		tl.to(nz, 0.25, {scale: 1});
		tl.to(au, 0.25, {scale: 1.35});
		tl.to(au, 0.25, {scale: 1});

		new ScrollMagic.Scene({
			triggerElement: trigger,
			offset: -100,
			reverse: false
		})
			.setTween(tl)
			//.addIndicators({name: 'contact'})
			.addTo(this.controller);
	},

	slowIntroScroll(heading, trigger, label) {
		let tl = new TimelineLite();
		tl.to(heading, 1, {y: 300});

		new ScrollMagic.Scene({
			triggerElement: trigger,
			offset: -200,
			duration: 1200
		})
			.setTween(tl)
			//.addIndicators({name: label})
			.addTo(this.controller);
	},

    getRandomInt(min = 100, max = 500) {
        let num = Math.floor(Math.random() * max) + min;
        num *= Math.floor(Math.random() * 2) === 1 ? 1 : -1;

        return num;
    }

}


// WEBPACK FOOTER //
// ./src/js/layout/App/animations.js